import { copyToClipboard } from './index';

export const copyFormattedContent = async (htmlContent: string, plainText: string): Promise<void> => {
  try {
    if (navigator.clipboard && navigator.clipboard.write) {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([htmlContent], { type: 'text/html' }),
          'text/plain': new Blob([plainText], { type: 'text/plain' }),
        })
      ]);
    } else {
      copyToClipboard(plainText);
    }
  } catch (error) {
    copyToClipboard(plainText);
  }
};

